const moment = require('moment')
require('moment/locale/pt')
moment.updateLocale('moment/locale/pt', null)

class DateTimeService {

  getNow() {
    return moment();
  }

  getDuration(startDate: string, endDate: string): number {
    return Math.round(moment.duration(moment(endDate).diff(startDate)).asDays());
  }

  getPercent(remainingDays: number, duration: number) {
    return 100 - (remainingDays * 100 / duration);
  }

  getPercentage(startDate: string, endDate: string) {
    return this.getRemainingDays(startDate, endDate) * 100 / this.getDuration(startDate, endDate);
  }

  getRemainingDays(startDate: string, endDate: string, ) {
    const now = moment();
    let remaingDays: number;

    if (now.diff(startDate) < 0) {
       remaingDays = 0;
    } else {
       remaingDays = this.getDuration(now, endDate);
    }

    return Math.max(0, Math.round(remaingDays));
  }

  getMonthString(number: number) {
    const month = moment(number, 'M').format('MMM');
    return month[0].toUpperCase() + month.substr(1);
  }

  getDateMinusDays(number: number) {
    const date = moment().subtract(number, "days");
    return date;
  }

  getDateFromString(year: number, month: number, day: number) {
    const date = moment(year + "-" + month + "-" + day, "YYYY-M-D");
    return date;
  }
}

export default new DateTimeService();